import Stack from "@mui/material/Stack"
import Typography from "@mui/material/Typography"

import DialogProvider from "@components/dialog_provider"
import { useAppContext } from "@contexts/app_context"

export default function ExpiredTokenWarning() {
  const { translate } = useAppContext()

  function handleClose() {
    //todo: convert this logic to reusable function
    const oldLang = localStorage.getItem("i18nextLng") || "en"
    localStorage.clear()
    localStorage.setItem("i18nextLng", oldLang)
    const currentUrl = window.location.pathname + window.location.search
    const loginUrl = `/public/login?redirectUrl=${encodeURIComponent(currentUrl)}`
    window.location.replace(loginUrl)
  }

  return (
    <DialogProvider
      title={translate("expired_token_title")}
      rightButton={{
        text: translate("back_to_login"),
        color: "primary",
        onClick: handleClose
      }}
      isOpen={true}
      setClose={() => console.log("you want to close it")}
      size="small"
    >
      <Stack flex={1} gap={3}>
        <Stack>
          <Typography>{translate("expired_token_description")}</Typography>
        </Stack>
        <Stack flex={1}>
          <Typography>{translate("expired_token_reason_1")}</Typography>
          <Typography>{translate("expired_token_reason_2")}</Typography>
          <Typography>{translate("expired_token_reason_2")}</Typography>
        </Stack>
        <Stack>
          <Typography>{translate("expired_token_contact_support")}</Typography>
        </Stack>
        <Stack>
          <Typography>{translate("expired_token_suggestion")}</Typography>
        </Stack>
      </Stack>
    </DialogProvider>
  )
}
